module.exports = __webpack_public_path__ + "static/media/3_Foiled_06.b52e8b1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Papers/3_Foiled_06.jpg
// module id = 1711
// module chunks = 0